var map = {
	"./close-btn.webp": 1932,
	"./icon-caution.webp": 1933,
	"./icon-checked.webp": 1934,
	"./icon-contact-us.webp": 1935,
	"./icon-email.webp": 1936,
	"./icon-eye-close.webp": 1937,
	"./icon-eye-open.webp": 1938,
	"./icon-forget-phone.webp": 1939,
	"./icon-forget-whatsapp.webp": 1940,
	"./icon-google.webp": 1941,
	"./icon-login-email.webp": 1942,
	"./icon-password.webp": 1943,
	"./icon-robot-select.webp": 1944,
	"./icon-robot-unselect.webp": 1945,
	"./icon-telegram.webp": 1946,
	"./icon-user.webp": 1947,
	"./login-bg.webp": 1948,
	"./reglogin-bg-cn.webp": 1949,
	"./reglogin-bg-id.webp": 1950,
	"./reglogin-bg-ms.webp": 1951,
	"./reglogin-bg.webp": 1952,
	"./reglogin-m-bg-cn.webp": 1953,
	"./reglogin-m-bg-id.webp": 1954,
	"./reglogin-m-bg-ms.webp": 1955,
	"./reglogin-m-bg.webp": 1956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;